import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20Korean%20webtoon%20reading%20space%20with%20soft%20golden%20lighting%2C%20bookshelves%20filled%20with%20colorful%20comic%20books%2C%20a%20comfortable%20armchair%20by%20a%20warm%20window%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20focus%20background%2C%20digital%20art%2C%20webtoon%20aesthetic%2C%20cozy%20vibes&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫屋温馨阅读空间"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
          {t('common:siteName')}
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-xl text-background-50/80 font-body max-w-2xl leading-relaxed">
          {t('common:siteTagline')}
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/action"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('common:ctaButton')}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-50/30 text-background-50 rounded-full font-medium text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('common:navAbout')}
          </Link>
        </div>

        <div className="mt-12 md:mt-16 flex items-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">3,200+</p>
            <p className="text-sm text-background-50/60 mt-1">漫画作品</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
            <p className="text-sm text-background-50/60 mt-1">忠实漫迷</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">每日更新</p>
            <p className="text-sm text-background-50/60 mt-1">永不断更</p>
          </div>
        </div>
      </div>
    </section>
  );
}